import { BUILDING_FORM_FIELD_NAME_INSURANCES } from '../BuildingForm.constants'

export function getBuildingFormInsuranceFieldName({ index, name }) {
  return `${BUILDING_FORM_FIELD_NAME_INSURANCES}[${index}].${name}`
}
